import { Injectable } from '@angular/core';

@Injectable()
export class WorkflowConfigService {
  defaults() {
    return {
      loaderImage : 'assets/images/loader.gif',
      workflow: [{
              id: 1,
              product: "PostPaid",
              leadStage: "L3Submitted",
              crifResult: "Accept",
              documentStatus: "All 7 documents uploaded",
              nextApplicationStatus: "Logged in"
          }, {
              id: 2,
              product: "PostPaid",
              leadStage: "L3Submitted",
              crifResult: "Refer",
              documentStatus: "All 7 documents uploaded",
              nextApplicationStatus: "Referred"
          }, {
              id:3,
              product: "PostPaid",
              leadStage: "L3Submitted",
              crifResult: "Not equal to Accept neither Refer",
              documentStatus: "All 7 documents uploaded",
              nextApplicationStatus: "Sales Reject"
          }, {
              id: 4,
              product: "Prepaid",
              leadStage: "L3Submitted",
              crifResult: "CRIF result is not pulled",
              documentStatus: "All 7 documents uploaded",
              nextApplicationStatus: "Logged in"
          }, {
              id: 5,
              product: "Prepaid",
              leadStage: "L3Submitted",
              crifResult: "CRIF result is not pulled",
              documentStatus: "All 7 documents uploaded",
              nextApplicationStatus: "Logged in"
          }, {
              id: 6,
              product: "Prepaid",
              leadStage: "L3Submitted",
              crifResult: "CRIF result is not pulled",
              documentStatus: "All 7 documents uploaded",
              nextApplicationStatus: "Logged in"
          }, {
              id: 7,
              product: "PostPaid",
              leadStage: "L3Submitted",
              crifResult: "Accept",
              documentStatus: "Any one or more documents are not uploaded",
              nextApplicationStatus: "L3Submitted"
          }, {
              id: 8,
              product: "PostPaid",
              leadStage: "L3Submitted",
              crifResult: "Refer",
              documentStatus: "Any one or more documents are not uploaded",
              nextApplicationStatus: "L3Submitted"
          }, {
              id: 9,
              product: "PostPaid",
              leadStage: "L3Submitted",
              crifResult: "Not equal to Accept neither Refe",
              documentStatus: "Any one or more documents are not uploaded",
              nextApplicationStatus: "L3Submitted"
          }, {
              id: 10,
              product: "Prepaid",
              leadStage: "L3Submitted",
              crifResult: "CRIF result is not pulled",
              documentStatus: "Any one or more documents are not uploaded",
              nextApplicationStatus: "L3Submitted"
          }, {
              id: 11,
              product: "Prepaid",
              leadStage: "L3Submitted",
              crifResult: "CRIF result is not pulled",
              documentStatus: "Any one or more documents are not uploaded",
              nextApplicationStatus: "L3Submitted"
          }, {
              id: 12,
              product: "Prepaid",
              leadStage: "L3Submitted",
              crifResult: "CRIF result is not pulled",
              documentStatus: "Any one or more documents are not uploaded",
              nextApplicationStatus: "L3Submitted"
          }

      ],
      applicationStatusList:[
        { id: 1, name:'referred'},
        { id: 2, name:'salesrejected'},
        { id: 3, name:'levelthreesubmitted'},
        { id: 4, name:'leveltwosubmitted'},
        { id: 5, name:'levelonesubmitted'},
        { id: 6, name:'supervisorrejected'},
        { id: 7, name:'supervisoraccepted'},
        { id: 8, name:'creditrejected'},
        { id: 9, name:'creditreferred'},
        { id: 10, name:'creditaccepted'},
        { id: 10, name:'loggedin'}
      ]
     
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/lead/workflowConfig.service.ts